import { render, staticRenderFns } from "./_Nav.vue?vue&type=template&id=13704134&scoped=true"
import script from "./_Nav.vue?vue&type=script&lang=js"
export * from "./_Nav.vue?vue&type=script&lang=js"
import style0 from "./_Nav.vue?vue&type=style&index=0&id=13704134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13704134",
  null
  
)

export default component.exports